import {Component, Watch, Prop, Vue} from '@/node_modules/nuxt-property-decorator';
import {appModule} from '@/store/app';
import {officialModule} from '@/store/official';
import {SelectLayoutsVisual} from '@/configs/select-layouts-visual';
import * as $ from 'jquery';

@Component
export default class MoVisualLayout extends Vue {

    public visualList: any = SelectLayoutsVisual;
    public visualItem: any = { id: 1, color: 'bk' };
    public visualInterval: any;
    public scrollTop: number = 0;

    public mounted() {

        // Visual
        let i = 0;
        this.visualItem = this.visualList[i];
        appModule.updateNavBgColor(this.visualItem.color);

        i = 1;

        this.visualInterval = setInterval( () => {

            this.visualItem = this.visualList[i];

            if ($(window).scrollTop() > 200 || officialModule.navOpen) {
                appModule.updateNavBgColor('wh');

            } else {
                appModule.updateNavBgColor(this.visualItem.color);
            }

            if (i < this.visualList.length - 1) {
                i++;
            } else {
                i = 0;
            }

        }, 5400);

//         $(window).scroll(() => {
//             this.scrollTop = $(window).scrollTop;
//         });

    }

    public destroyed() {
        clearInterval(this.visualInterval)
    }

    public get deviceSize(): any {
        return appModule.deviceSize;
    }

}
